import { get } from 'react-hook-form';

export function getErrorMessage(errors: unknown, name: string) {
  return get(errors, name)?.message as string | undefined;
}
